export const wickUIVersionText: string = 'Wick UI version:'
export const wickUIIconsVersionText: string = 'Wick UI icons version:'
